import { User } from 'firebase/auth'
import { sendErrorMail } from '../mails/errorMail'
import { isDevMode } from '@/config'

export { MIN_PRODUCTS_FOR_ADS, has20OrMoreProducts, shouldShowMenuAds, getTotalProducts } from './menuAds'

export function handleError (error: unknown) {
  console.error(error)
  let errorMessage = 'Error desconocido en el servidor'

  if (error instanceof Error) {
    errorMessage = error.message
  } else if (typeof error === 'object' && error !== null) {
    errorMessage = JSON.stringify(error)
  } else if (typeof error === 'string') {
    errorMessage = error
  }

  if (!isDevMode) sendErrorMail(error)

  return errorMessage
}

export const getUserToken = async (user: User) => {
  // Valida si el usuario está autenticado
  let userToken
  if (user) {
    userToken = await user.getIdToken()
    return userToken
  } else {
    throw new Error('Problema con la verificación del Token')
  }
}

export function getURLParameter (req: Request, paramName: string): string | null {
  const url = new URL(req.url, `http://${req.headers.get('host')}`)
  return url.searchParams.get(paramName)
}
